import React from 'react';
import classnames from 'classnames';

import { is768Query } from '~/core/scripts/mediaquery-helper';
import Icon from '~/core/scripts/components/Icon';
import Utils from '~/core/scripts/utils';

import './tooltip.styl';

const TOOLTIP_WIDTH = 250;

const Tooltip = props => {
  const { data, pos, isVisible, onClose, isAlt} = props;
  const style = is768Query() ? { left: `${pos.x + 35}px`, top: `${pos.y - 75}px` } : {};
  const isInverted = pos.x + 35 + TOOLTIP_WIDTH >= window.innerWidth;
  const tooltipClass = classnames('tooltip-wrapper', { 'is-active': isVisible, invert: isInverted });

  if (!data) {
    return null;
  }

  const currValue = data.value;
  const currValueAlt = data.valueAlt;
  const title = data.title;
  const subtitle = data.subtitle;

  const handleClose = evt => {
    evt.preventDefault();
    evt.stopPropagation();

    onClose();
  };

  const altLabel = isAlt ? 'Einkommen (2016)' : 'Entwicklung (seit 2000)';
  const altNum = isAlt ? Utils.numberFormat(currValueAlt, 0, '€') : Utils.numberFormat(currValueAlt, 1 , '%', '+');

  return (
    <div className={tooltipClass} style={{ ...style, borderColor: data.color }}>
      <div className="tooltip">
        <button className="btn close" onClick={handleClose}>
          <Icon type="close" />
        </button>
        <div className="tooltip-header">
          <div className="tooltip-title">{title}</div>
          <div className="tooltip-subtitle">{subtitle}</div>
        </div>
          {currValue === 'na' ?
          <div className="tooltip-body">
            Keine Daten vorhanden
          </div> :
          <div className="tooltip-body">
            <div className="tooltip-label">{isAlt === true ? 'Entwicklung (seit 2000)' : 'Einkommen (2016)'}</div>
            <div className="tooltip-value">{isAlt === true ? Utils.numberFormat(currValue, 1, '%', '+') : Utils.numberFormat(currValue, 0 , '€')}</div>
            <div className="tooltip-alt">{altLabel}: <strong>{altNum}</strong></div>
          </div>
        }
      </div>
    </div>
  );
};

export default Tooltip;
